export const getFingerprint = (): string => {
  return btoa(
    navigator.userAgent +
    navigator.language +
    window.screen.width +
    window.screen.height
  );
};